import { Dispatch } from 'react'
import { ChevronLeft } from '../../../icons/ChevronLeft'

export const ClearSelectionsPopup = ({
  previewData,
  clearSelectionLinkPath,
  setShowClearSelectionsPopup,
  onClick
}: {
  previewData: string
  clearSelectionLinkPath: string
  setShowClearSelectionsPopup: Dispatch<React.SetStateAction<boolean>>
  onClick: () => void
}) => {
  return (
    <div className="w-full">
      <div className="sticky z-10 top-0 bg-white w-full flex items-center justify-between px-5 py-[17px]">
        <div className="relative flex items-center justify-center gap-4 flex-1 border-0">
          <button
            type="button"
            onClick={() => setShowClearSelectionsPopup(false)}
            className="absolute left-0 top-1/2 -translate-y-1/2"
          >
            <ChevronLeft />
          </button>
          <p className="uppercase text-sm">Selections</p>
        </div>
      </div>
      <div className="flex flex-col flex-1 text-center px-5 md:px-[60px]">
        <h4 className="text-xl uppercase font-light mb-[30px] tracking-normal mt-[73px] md:mt-[90px] md:mb-[45px] md:text-2xl">Clear Selections</h4>
        <div className="relative bg-[#e8e8e8] mx-auto w-[206px] h-auto aspect-[206/210]">
          {previewData ? (
            <img className="absolute inset-0 aspect-[206/210] object-cover" src={previewData} alt="preview image of current selection" />
          ) : (
            <div className="absolute inset-0 aspect-[206/210] bg-gradient-to-br from-[#f0f0f0] to-[#9b9b9b]"></div>
          )}
        </div>
        <p className="my-[30px] text-sm-c md:my-[45px]">Are you sure you want to clear all your selections? This will reset the live preview and take you back to the first step.</p>
        {clearSelectionLinkPath ? (
          <a href={clearSelectionLinkPath} className="w-full Button Button--tertiary border border-deep-grey">
            Yes
          </a>
        ) : (
          <button
            onClick={() => onClick()}
            className="Button Button--tertiary w-full border border-deep-grey"
          >
            Yes
          </button>
        )}
        <button onClick={() => setShowClearSelectionsPopup(false)} className="w-full mt-2.5 Button Button--secondary-dark border border-deep-grey">
          No
        </button>
        <button
          onClick={() => setShowClearSelectionsPopup(false)}
          className="flex items-center justify-center uppercase underline underline-offset-4 font-calibre text-sm-b mt-5 md:mt-[30px] hover:text-subdued"
        >
          Back To Summary
        </button>
      </div>
    </div>
  )
}
